import { useEffect, useRef, useState } from 'react'

import { useAdFree } from 'hooks/adFree'

import Icon from 'components/elements/Icon'
import SimpleSpinner from 'components/elements/SimpleSpinner'

import styles from './inhouseVideoAd.module.scss'

const VideoAd = () => {
  const adStartHandler = useRef<() => void>(() => null)
  const adStopHandler = useRef<() => void>(() => null)

  const adFree = useAdFree()

  const [closed, setClosed] = useState(false)
  const [adActive, setAdActive] = useState(true)

  useEffect(() => {
    if (adFree) return

    adStartHandler.current = () => setAdActive(true)
    adStopHandler.current = () => setAdActive(false)

    document.addEventListener('ads:floatingPlayerShow', adStartHandler.current)
    document.addEventListener('ads:floatingPlayerHide', adStopHandler.current)

    return () => {
      document.addEventListener('ads:floatingPlayerShow', adStartHandler.current)
      document.addEventListener('ads:floatingPlayerHide', adStopHandler.current)
    }
  }, [adFree])

  if (adFree) return null
  if (closed) return null

  return (
    <div className={`${styles.videoContainer} ${adActive ? '' : styles.hidden}`} id="video-player-container">
      <button className={styles.close} onClick={() => setClosed(true)}>
        <Icon name="close" />
      </button>
      <div className={styles.videoAd} id="demo-video-player" data-ad-slot="floating">
        <SimpleSpinner size="medXSmall" />
      </div>
    </div>
  )
}

export default VideoAd
